module.exports = __webpack_public_path__ + "img/NormalSeat_GreenMetallic.42582806.png";